import type { Provider } from '@app/src/types/organizations'
import { ErrorOutlineOutlined } from '@mui/icons-material'
import { Stack } from '@mui/material'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import ProvidersAccordionConditionalCheck from './ProvidersAccordionConditionalCheck'
import type { ScheduleScreeningFormData } from './ScheduleProviderScreeningModal'
import { SCHEDULE_SCREENING_QUESTION_KEYS } from './ScheduleProviderScreeningModal'

type ProvidersMissingWebsiteProps = {
  providersMissingWebsite: Provider[]
}

const ProvidersMissingWebsite: React.FC<ProvidersMissingWebsiteProps> = ({ providersMissingWebsite }) => {
  const { formatMessage } = useIntl()
  const { watch, setValue, getValues } = useFormContext<ScheduleScreeningFormData>()

  const watchProviders = watch(SCHEDULE_SCREENING_QUESTION_KEYS.PROVIDER_IDS)

  const handleChangeSetFormValues = (providerId: number) => {
    const toBeChecked = !watchProviders.includes(providerId)

    if (toBeChecked) {
      setValue(SCHEDULE_SCREENING_QUESTION_KEYS.PROVIDER_IDS, Array.from(new Set([...watchProviders, providerId])))
    } else {
      setValue(
        SCHEDULE_SCREENING_QUESTION_KEYS.PROVIDER_IDS,
        watchProviders.filter(watchProviderId => watchProviderId !== providerId),
      )
    }
  }

  // The drawer keeps this callback from when it opened, so read the selection at save time
  const selectProvider = (providerId: number) => {
    const selectedProviderIds = getValues(SCHEDULE_SCREENING_QUESTION_KEYS.PROVIDER_IDS)
    setValue(SCHEDULE_SCREENING_QUESTION_KEYS.PROVIDER_IDS, Array.from(new Set([...selectedProviderIds, providerId])))
  }

  return (
    <Stack spacing={3}>
      <ProvidersAccordionConditionalCheck
        title={formatMessage(
          { id: 'form.scheduleProviderScreening.websiteMissing.information' },
          { count: providersMissingWebsite.length },
        )}
        providers={providersMissingWebsite}
        selectedProviderIds={watchProviders}
        onChange={handleChangeSetFormValues}
        onWebsiteSaved={selectProvider}
        icon={<ErrorOutlineOutlined sx={{ color: 'semantic.error' }} />}
        defaultExpanded
      />
    </Stack>
  )
}

export default ProvidersMissingWebsite
